import { useAppSelector } from '../../../app/hooks'

export const useConnectedCalendar = () => {
  var connectedCalendar = useAppSelector((state) => state?.user?.data?.userSettings?.connectedCalendar?.name)

  return connectedCalendar
}
